module.exports = __webpack_public_path__ + "00063201a093399fcc4abb5610cdfa6f.svg";